import { Price } from './product/uiProduct';
import _ from 'lodash';
import z from 'zod';

export type PriceType = z.infer<typeof PriceType>;
export type CurrentPrice = z.infer<typeof CurrentPrice>;

export const PriceType = z.enum(['default', 'action', 'discount', 'substitute']);

export const CurrentPrice = z.object({
    price: z.number(),
    priceType: PriceType,
    discount: z.number().nullish(),
});

export const getCurrentPrice = (prices: Price[], t = new Date()): CurrentPrice | undefined => {
    const nextDay = (d: Date) => new Date(new Date(d).setUTCDate(d.getUTCDate() + 1));

    const current = _(prices)
        .filter((price) => price.priceTC === '00' || price.priceTC === '01')
        .filter((x) => new Date(x.validFrom) <= t && nextDay(new Date(x.validTo)) > t)
        .orderBy(['priceTC', 'validFrom'], ['desc', 'desc'])
        .first();

    return (
        current && {
            price: current.priceint,
            priceType: current.priceTC === '01' ? 'action' : 'default',
            discount: current.discount,
        }
    );
};
